var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"text-white scan-qr-btn",attrs:{"outline":"","variant":"link"},on:{"click":_vm.onScanQrClick}},[_c('font-awesome-icon',{attrs:{"icon":"qrcode"}}),_vm._v("\n  "+_vm._s(_vm.$t("Scan QR"))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }